<template>
  <div class="container">
    <iframe :src="src" ref="iframe" frameborder="0" width="100%" height="660px"></iframe>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      src:""
      // src:"/static/aotongPlay.html",
    };
  },
  methods: {
      
  },
  mounted() {
    // let serialNumber = this.$route.query.serialNumber;
    // let streamToken = this.$route.query.streamToken;
    // let backgroundImg = this.$route.query.backgroundImg;
    this.src="/static/mohe/index.html";
    // this.src="/static/aotongPlay.html?serialNumber="+serialNumber+"&streamToken="+streamToken+"&back="+backgroundImg;
  }
};
</script>
<style lang="scss" scoped>
.playcav {
  transform: scaleX(-1);
  width: 100%;
  height: 90vh;
  max-height: 92%;
  background-size: cover;
}
.container{
  padding: 0px;
  overflow-y: hidden;
}
</style>
  